const LEARNING_MANAGER_API = {
	LEARNING_PATHS: '/learning-paths',
	LEARNING_PATH: (id: number) => `/learning-paths/${id}`
};

export default LEARNING_MANAGER_API;
